var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFilledDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      marginLeft: 2
    },
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9867 0.941388C11.6055 -0.313796 13.3945 -0.313796 14.0133 0.941388L16.9613 6.91352L23.5535 7.87116C24.9375 8.07244 25.49 9.77394 24.4886 10.7503L19.7179 15.401L20.8443 21.9645C21.0819 23.3434 19.6342 24.3948 18.3952 23.7447L12.4994 20.6443L6.60476 23.7447C5.36708 24.3948 3.91936 23.3447 4.1544 21.9645L5.28081 15.401L0.511364 10.7503C-0.490033 9.77519 0.0625485 8.07244 1.4465 7.87116L8.03872 6.91352L10.9867 0.941388Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilledDark);
export default __webpack_public_path__ + "static/media/StarFilled_Dark.fae0bf5c1e7ddc70cfef9d2a29683e4e.svg";
export { ForwardRef as ReactComponent };